import type { OperationContext, OperationResult } from "urql"
import { useMutation } from "urql"

import type {
  CompanyCertificationMutationBatchDeleteCompanyCertificationArgs,
  CompanyCertificationMutationCreateArgs,
  CompanyCertificationMutationUpdateArgs,
  Mutation,
} from "@/graphql/codegen/graphql"
import {
  CreateCompanyCertificationMutationDocument,
  DeleteCompanyCertificationMutationDocument,
  UpdateCompanyCertificationMutationDocument,
} from "@/graphql/codegen/graphql"

interface UseCompanyCertificationMutationReturn {
  createCertification: (
    variables: CompanyCertificationMutationCreateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "companyCertification">, CompanyCertificationMutationCreateArgs>>
  updateCertification: (
    variables: CompanyCertificationMutationUpdateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "companyCertification">, CompanyCertificationMutationUpdateArgs>>
  deleteBatchCertifications: (
    variables: CompanyCertificationMutationBatchDeleteCompanyCertificationArgs,
    context?: Partial<OperationContext>
  ) => Promise<
    OperationResult<
      Pick<Mutation, "companyCertification">,
      CompanyCertificationMutationBatchDeleteCompanyCertificationArgs
    >
  >
}

const useCompanyCertificationMutation = (): UseCompanyCertificationMutationReturn => {
  const [, createCertification] = useMutation<
    Pick<Mutation, "companyCertification">,
    CompanyCertificationMutationCreateArgs
  >(CreateCompanyCertificationMutationDocument)

  const [, updateCertification] = useMutation<
    Pick<Mutation, "companyCertification">,
    CompanyCertificationMutationUpdateArgs
  >(UpdateCompanyCertificationMutationDocument)

  const [, deleteBatchCertifications] = useMutation<
    Pick<Mutation, "companyCertification">,
    CompanyCertificationMutationBatchDeleteCompanyCertificationArgs
  >(DeleteCompanyCertificationMutationDocument)

  return {
    createCertification,
    updateCertification,
    deleteBatchCertifications,
  }
}

export default useCompanyCertificationMutation
